import * as React from 'react';
import { Text } from '@lightspeed/flame/Text';

import { useMoney } from '~/renderer/hooks/.';

import { ItemTd } from './ReceiptItem.style';

interface ReceiptItemSubTotalProps {
  lineNumber: number;
  displayableSubTotal: number;
  isGroupedItemHead: boolean;
  isGroupedItem: boolean;
  normalUnitPrice?: number;
  quantity: number;
}

interface SubTotalProps {
  displayableSubTotal: number;
  lineNumber: number;
  normalUnitPrice?: number;
  quantity: number;
}

const SubTotal: React.FunctionComponent<SubTotalProps> = ({
  displayableSubTotal,
  lineNumber,
  normalUnitPrice,
  quantity,
}) => {
  const { money } = useMoney();
  const isNormalUnitPriceVisible =
    normalUnitPrice && normalUnitPrice * quantity > displayableSubTotal;
  const getUnitPrice = (price: number, unitQuantity: number): string => {
    const unitPrice = price * unitQuantity;
    if (Number.isNaN(unitPrice) || !Number.isFinite(unitPrice)) return '0';

    return String(unitPrice);
  };
  return (
    <>
      {isNormalUnitPriceVisible ? (
        <Text
          lineHeight="normal"
          size="small"
          className="large"
          color="gray-400"
          style={{
            textDecoration: 'line-through',
          }}
          data-testid={`saleLine-${lineNumber}-subtotal-line-through`}
        >
          {money(getUnitPrice(normalUnitPrice || 0, quantity))}
        </Text>
      ) : null}
      <Text
        lineHeight="normal"
        size="large"
        className="large"
        data-testid={`saleLine-${lineNumber}-subtotal`}
      >
        {money(String(displayableSubTotal))}
      </Text>
    </>
  );
};

const ReceiptItemSubTotal: React.FunctionComponent<ReceiptItemSubTotalProps> = ({
  displayableSubTotal,
  lineNumber,
  isGroupedItemHead,
  isGroupedItem,
  normalUnitPrice,
  quantity,
}) => {
  return (
    <ItemTd
      as="td"
      p={2}
      pr={3}
      isGroupedItem={isGroupedItem}
      style={{ textAlign: 'right', whiteSpace: 'nowrap', verticalAlign: 'baseline' }}
    >
      {isGroupedItemHead ? null : (
        <SubTotal
          displayableSubTotal={displayableSubTotal}
          lineNumber={lineNumber}
          normalUnitPrice={normalUnitPrice}
          quantity={quantity}
        />
      )}
    </ItemTd>
  );
};

export { ReceiptItemSubTotal };
